import React, { FC } from 'react'

export const FilterPanel: FC = ({ children }) => <>{children}</>
FilterPanel.displayName = 'ListPage.FilterPanel'
